export const company = {
  name: "Ulrich Arzt Präzisions-Mechanik Sondermaschinen GmbH",
  shortName: "Ulrich Arzt",
  claim: "Präzisions-Mechanik · Sondermaschinen",
  founded: "1963",
  street: "Geschwand 111",
  zip: "91286",
  city: "Obertrubach",
  region: "Fränkische Schweiz",
  country: "Deutschland",
  phone: "+49 9197 / 1404",
  phoneHref: "+4991971404",
  fax: "+49 9197 / 392",
  email: "mail@arzt-pms.de",
  manager: "Jochen Arzt",
  register: "Registergericht Bamberg HRB 2151",
  vat: "DE 132 504 114",
  hours: [
    { days: "Montag – Donnerstag", time: "06:30 – 12:00 und 12:45 – 16:00" },
    { days: "Freitag", time: "06:30 – 11:30" },
  ],
  motto: "Qualität und Individualität — made in Germany",
};

export const brandAssets = {
  bannerLogo: "https://arzt-pms.de/images/design/logo_full_topFrame.jpg",
  mark: "https://arzt-pms.de/images/logo_A_100x100.png",
  eMobilityMark: "https://arzt-pms.de/images/logo_E.png",
  machineBanner: "https://arzt-pms.de/images/sondermaschinenMerge.jpg",
  pictogram: "https://arzt-pms.de/images/piktogramm.png",
  heroMachine: "https://arzt-pms.de/images/produkte/slideshow/slideSond_005.jpg",
  machineDetail: "https://arzt-pms.de/images/produkte/slideshow/slideSond_007.jpg",
  machineDetailAlt: "https://arzt-pms.de/images/produkte/slideshow/slideSond_009.jpg",
  pitch: "https://arzt-pms.de/images/produkte/slideshow/slideCamp_002.jpg",
  pitchAlt: "https://arzt-pms.de/images/produkte/slideshow/slideCamp_004.jpg",
  pitchThird: "https://arzt-pms.de/images/produkte/slideshow/slideCamp_006.jpg",
  charging: "https://arzt-pms.de/images/produkte/slideshow/slideECharge_001.jpg",
  chargingAlt: "https://arzt-pms.de/images/produkte/slideshow/slideECharge_003.jpg",
};

export const navigation = [
  { label: "Startseite", href: "/" },
  { label: "Produkte", href: "/produkte" },
  { label: "Unternehmen", href: "/unternehmen" },
  { label: "Kontakt", href: "/kontakt" },
];

export const highlights = [
  { value: "1963", label: "gegründet in Geschwand" },
  { value: "3.", label: "Generation Familienbetrieb" },
  { value: "60+", label: "Jahre Erfahrung" },
];

export const businessFields = [
  {
    id: "sondermaschinen",
    index: "01",
    title: "Vorrichtungs- & Sondermaschinenbau",
    lead: "Unser Hauptgeschäftsfeld: Entwicklung und Herstellung von Sondermaschinen und Vorrichtungen sowie Fertigung von Einzelteilen und Kleinserien.",
    body:
      "Wir greifen auf langjährige Erfahrung aus verschiedenen Branchen zurück und setzen unser Know-how gezielt zur Steigerung von Qualität und Funktionalität ein. Konventionelle und CNC-gesteuerte Maschinen kommen dabei ebenso zum Einsatz wie Rund- und Flachschleifen, Senkerodieren oder Lichtbogen- und Schutzgasschweißen — alles im eigenen Haus.",
    bullets: [
      "Sondermaschinen nach Kundenwunsch",
      "Vorrichtungen",
      "Einzelteile und Kleinserien",
      "Konventionelle und CNC-gesteuerte Bearbeitung",
      "Rund- / Flachschleifen, Senkerodieren",
      "Lichtbogen- / Schutzgasschweißen",
    ],
    image: brandAssets.machineDetail,
    imageAlt: "Sondermaschine aus der Fertigung in Geschwand",
  },
  {
    id: "stellplatzausstattung",
    index: "02",
    title: "Ausstattung für Stell- & Campingplätze",
    lead:
      "Ver- und Entsorgungsanlagen sowie Strom-/Wassersäulen — konsequent aus nichtrostendem Edelstahl gefertigt.",
    body:
      "Bei der Entwicklung legen wir den Fokus auf Robustheit, Langlebigkeit und hochwertige Qualität. Bewährte Technik in den Komponenten sorgt für eine intuitive und störungsfreie Bedienung. Durch die Produktvielfalt können wir nahezu jedem Stellplatzbetreiber eine optimale und effektive Ausstattung anbieten — inklusive individueller Sondermodelle.",
    bullets: [
      "Edelstahl, nichtrostend",
      "Robust und langlebig",
      "Intuitive, störungsfreie Bedienung",
      "Individuelle Sondermodelle",
      "Münzbetrieb möglich",
      "Erweiterbar mit Strom- und Wassersäulen",
    ],
    image: brandAssets.pitch,
    imageAlt: "Ver- und Entsorgungsanlage auf einem Campingplatz",
  },
  {
    id: "e-ladestationen",
    index: "03",
    title: "Ladestationen für Elektrofahrzeuge",
    lead:
      "Ladesäulen für aktuelle und kommende Fahrzeuggenerationen — und für E-Bikes und Pedelecs.",
    body:
      "Mit Blick auf die Mobilitätsform der Zukunft haben wir unser Produktportfolio erweitert. Unsere Produktserie umfasst verschiedene Varianten von Ladesäulen, die in der von uns gewohnten Qualität gefertigt werden: innovative Technik, robust und langlebig, einfach zu bedienen.",
    bullets: [
      "Ladesäulen für aktuelle und kommende Fahrzeuggenerationen",
      "Ladestationen für E-Bikes und Pedelecs",
      "Innovative Technik",
      "Robust und langlebig",
      "Einfach zu bedienen",
    ],
    image: brandAssets.charging,
    imageAlt: "Ladesäule für Elektrofahrzeuge",
  },
];

export const silverModels = [
  {
    name: "Silver C",
    note: "Die preiswerte Alternative",
    text: "Grundausstattung mit Druckspülung des Abwasserschachtes und Frischwasserversorgung. Da kein Stromanschluss nötig ist, eignet sie sich auch für hochwassergefährdete Gebiete. Ebenerdiger Einbau möglich.",
    specs: "3 mm Edelstahl · 700 × 700 × 830 mm",
  },
  {
    name: "Silver S",
    note: "Frischwasser münzgesteuert",
    text: "Komplett aus rostfreiem Edelstahl: kostenpflichtige, münzgesteuerte Frischwasserabgabe, kostenfreie Abwasserentsorgung, automatische Schachtspülung und sensorgesteuerte Beleuchtung.",
    specs: "3 mm Edelstahl · 700 × 900 × 1500 mm",
  },
  {
    name: "Silver xS",
    note: "Die Kompakte",
    text: "Aus Edelstahl gefertigt und mit moderner Technik ausgestattet: Münzprüfer für den Frischwasserverkauf und elektrische Schachtspülung gehören zur Serie.",
    specs: "Edelstahl · 240 × 380 × 1150 mm",
  },
  {
    name: "Silver MaxX",
    note: "Frisch- und Abwasser münzgesteuert",
    text: "Die große Ausführung: Sowohl Frischwasserversorgung als auch Abwasserentsorgung erfolgen münzgesteuert. Automatische Schachtspülung und sensorgesteuerte Beleuchtung sind Serie.",
    specs: "3 mm Edelstahl · 700 × 900 × 1500 mm",
  },
  {
    name: "Silver K",
    note: "Die kleine mit der Technik einer Großen",
    text: "Komplett aus Edelstahl, mit Münzprüfer für den Frischwasserverkauf und elektrischer Abwasserspülung bereits in der Serienausstattung — optional mit zweitem Wasserhahn.",
    specs: "Edelstahl · 600 × 450 × 1500 mm",
  },
];

export const pitchProducts = [
  {
    name: "Kassettenausguss KA",
    text: "Entleerung der Kassettentoilette auf kleinstem Raum — außen wie innen. Hygienisch entleeren, auf Tastendruck sauber spülen; einstellbare Spülung über Edelstahlrohr, ca. 280 × 280 × 780 mm.",
  },
  {
    name: "Bodeneinlass, überfahrbar",
    text: "Bodeneinlass für die Entsorgung von Grauwasser: integrierte Spülung, überfahrbarer Edelstahlrost, mit jeder unserer Anlagen kombinierbar, ca. 1000 × 350 mm.",
  },
  {
    name: "Strom-/Wassersäulen",
    text: "Münzstromsäule, Komfortäule sowie Strom-/Wassersäulen in 2- oder 4-fach-Ausführung — mit oder ohne Wasseranschluss, zeit- oder verbrauchsgesteuert.",
  },
];

export const processSteps = [
  {
    step: "01",
    title: "Anfrage & Beratung",
    text: "Wir hören zu, prüfen die Anforderung und schlagen eine technisch sinnvolle Lösung vor — direkt mit der Werkstatt im Rücken.",
  },
  {
    step: "02",
    title: "Konstruktion",
    text: "Zeichnung, Auslegung und Materialauswahl entstehen im Haus. Änderungswünsche fließen kurz und unkompliziert ein.",
  },
  {
    step: "03",
    title: "Fertigung",
    text: "Zerspanung, Schweißarbeiten und Oberflächenbehandlung laufen in eigenen Fertigungsprozessen — konventionell und CNC.",
  },
  {
    step: "04",
    title: "Montage & Service",
    text: "Aufbau, Inbetriebnahme und Ersatzteile: Wir bleiben nach der Lieferung der Ansprechpartner für die Anlage.",
  },
];

export const timeline = [
  {
    year: "1963",
    title: "Gründung",
    text: "Ulrich Arzt gründet in Geschwand den Betrieb „Ulrich Arzt Maschinenbau“ — kleine Sondermaschinen, Metallbearbeitung und individuell gefertigte Geländer für Treppenhäuser und Balkone.",
  },
  {
    year: "1976",
    title: "Familie im Betrieb",
    text: "Karola Arzt, Tochter des Firmengründers, steigt in das Firmengeschehen ein.",
  },
  {
    year: "1983",
    title: "Verstärkung",
    text: "Klaus Arzt kommt in den Betrieb. Die Auftragslage wächst, bestehende Räume werden erweitert und ausgebaut.",
  },
  {
    year: "1987",
    title: "Neue Halle, neue Technik",
    text: "Nach Fertigstellung der neuen Firmenhalle folgt der Umzug — mit neuen CNC-Fräs- und CNC-Drehmaschinen. Die Firma wird in „Ulrich Arzt Präzisions-Mechanik Sondermaschinen“ umbenannt.",
  },
  {
    year: "ab 1987",
    title: "Relaisproduktion",
    text: "Ein Teil der Relaisproduktion der damaligen Firma Eberle wird übernommen — bis zu 45 weitere Arbeitskräfte werden in der Fertigung beschäftigt.",
  },
  {
    year: "2000",
    title: "Dritte Generation",
    text: "Jochen Arzt ist an der Zukunftsorientierung und der Gestaltung effektiver Produktionsabläufe beteiligt.",
  },
  {
    year: "Heute",
    title: "Dritte Generation, über 60 Jahre",
    text: "Der Betrieb besteht in dritter Generation und blickt auf über 60 Jahre Erfahrung zurück — mit dem Anspruch, spezielle Lösungen und Sonderanfertigungen umzusetzen.",
  },
];

export const capabilities = [
  { title: "CNC-Fräsen", text: "Mehrachsige Bearbeitung von Einzelteilen und Kleinserien." },
  { title: "CNC-Drehen", text: "Präzisionsdrehteile nach Zeichnung, eng toleriert." },
  { title: "Rundschleifen", text: "Passgenaue Oberflächen und Maßhaltigkeit im Haus." },
  { title: "Flachschleifen", text: "Planflächen mit hoher Genauigkeit für Vorrichtungen." },
  { title: "Senkerodieren", text: "Komplexe Konturen, die spanend kaum erreichbar sind." },
  { title: "Schweißtechnik", text: "Lichtbogen- und Schutzgasschweißen für Anlagen und Gestelle." },
  { title: "Edelstahlverarbeitung", text: "Nichtrostender Edelstahl für Camping- und Säulenanlagen." },
  { title: "Montage", text: "Vormontage, Aufbau und Inbetriebnahme beim Kunden." },
];

export const values = [
  {
    icon: "ri-ruler-2-line",
    title: "Präzision",
    text: "Maße, Toleranzen, Funktion. Wir fertigen so, dass es passt — nicht ungefähr.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Robustheit",
    text: "Anlagen, die Wind, Wetter und täglicher Nutzung standhalten. Edelstahl statt Kompromiss.",
  },
  {
    icon: "ri-user-heart-line",
    title: "Familienbetrieb",
    text: "Kurze Wege, feste Ansprechpartner und Entscheidungen, die vor Ort fallen.",
  },
  {
    icon: "ri-tools-line",
    title: "Eigenfertigung",
    text: "Zerspanung, Schleifen, Erodieren und Schweißen — im eigenen Haus, in eigener Hand.",
  },
];

export const downloads = [
  {
    label: "Broschüre Campingprodukte (PDF)",
    href: "https://arzt-pms.de/service/download/camping-katalog/",
  },
];

export const productAnchors = [
  { label: "Sondermaschinenbau", href: "#sondermaschinen" },
  { label: "Stellplatzausstattung", href: "#stellplatzausstattung" },
  { label: "E-Ladestationen", href: "#e-ladestationen" },
];